(function () {
	'use strict';

	angular
		.module('wizard-english-test.directives')
		.directive('footer', Footer)

	/** @ngInject */
	function Footer(PATHS) {
		function FooterController() {

		}

		return {
			bindToController: true,
			controller: FooterController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/footer/footer.html`,
			scope: {}
		}
	}
}());